import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import _ from 'lodash';
import { query } from '@/views/demand/utils';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import SearchBar from '../components/search.vue';
import DemandList from '../components/table.vue';
import DownloadButton from '@/components/DownloadButton/index.vue';
import autoTips from '@/components/AutoTips';
import creativeDetail from '../components/creative-detail.vue';
import featureTagConfig from '../configuration-scheme/feature-tag-config.vue';
import { getAppTagList } from '@/api/system/app-tag';
import { fetchCreationList, updateMaterialTag } from '@/api/demand/creation';

export default {
  components: {
    creativeDetail: creativeDetail,
    Pagination: Pagination,
    SearchBar: SearchBar,
    DemandList: DemandList,
    autoTips: autoTips,
    DownloadButton: DownloadButton,
    featureTagConfig: featureTagConfig
  },
  mixins: [searchMixin],
  watch: {
    $route: function $route(to, from) {
      this.getDemandList();
    }
  },
  data: function data() {
    return {
      pagination: {
        total: 0
      },
      query: _.pick(query, ['search_field', 'keyword', 'creation_types', 'category', 'channels', 'languages', 'designer_ids', 'demander_ids', 'search_time', 'time', 'tag_ids', 'page', 'page_size']),
      formItems: _Object$keys(_.pick(query, ['search_field', 'keyword', 'creation_types', 'tag_ids', 'channels', 'languages', 'designer_ids', 'demander_ids', 'search_time', 'time', 'category'])),
      columnConfig: ['id', 'creation-cell', // 创意名称
      'tag_names', // 创意标签
      'material_tag_names', // 特征标签
      'attachment_size', 'demand_name', // 关联需求
      'submit_time', 'designer_name', 'demander_name', // 提需人
      'deliver_time', // 实际完成日期
      'action-cell'],
      keyField: [{
        value: 'id',
        label: '创意ID'
      }, {
        value: 'name',
        label: '创意名称'
      }, {
        value: 'demand_id',
        label: '需求ID'
      }, {
        value: 'demand_name',
        label: '需求名称'
      }],
      demandList: [],
      listLoading: false,
      creativeDetailData: {
        visible: false,
        title: '',
        id: 0
      },
      downloadBtnConfig: {
        icon: '',
        type: 'text'
      },
      dialogConfig: {
        title: '更新特征标签',
        visible: false,
        loading: false
      },
      dialogValue: {
        id: '',
        tag_ids: ''
      },
      formConfig: {},
      schemeValue: {
        featureTagData: []
      },
      autoCompleteTag: ''
    };
  },

  methods: {
    getDemandList: function getDemandList(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;

                _context.prev = 1;
                _context.next = 4;
                return fetchCreationList(_this.cookQueryParams(params || _this.query));

              case 4:
                res = _context.sent;

                _this.demandList = _this.addRowsSpan(_.get(res, 'data.data.list')).map(function (item) {
                  return _extends({}, item, {
                    tag_names: item.tag_names ? item.tag_names : '-'
                  });
                });
                _this.pagination.total = _.get(res, 'data.data.total');
                _this.listLoading = false;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    },
    cookQueryParams: function cookQueryParams(params) {
      var cloneParams = _.cloneDeep(params);
      if (cloneParams.tag_ids.length) {
        var tagArray = [];
        cloneParams.tag_ids.forEach(function (item) {
          tagArray.push(Number(item[item.length - 1]));
        });
        cloneParams.tag_ids = tagArray;
      }
      return cloneParams;
    },
    handleSpanMethod: function handleSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex === 4) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    addRowsSpan: function addRowsSpan(list) {
      var demandNameList = [];
      if (!list) return []; // 异常处理
      list.forEach(function (e) {
        if (demandNameList.indexOf(e.demand_id) === -1) {
          demandNameList.push(e.demand_id);
          e.rowspan = list.filter(function (item) {
            return item.demand_id === e.demand_id;
          }).length;
        } else {
          e.rowspan = 0;
        }
      });
      return list;
    },
    seeDetails: function seeDetails(row) {
      this.creativeDetailData.title = row.name;
      this.creativeDetailData.id = row.id;
      this.creativeDetailData.visible = true;
    },
    fetchAllData: function fetchAllData() {
      var postData = _Object$assign({}, this.query, {
        page_size: this.pagination.total
      });
      return fetchCreationList(postData);
    },
    isGameByAppCatId: function isGameByAppCatId(row) {
      // 游戏的cids为8~16
      var list = [{ id: 8, name: '动作' }, { id: 9, name: '角色扮演' }, { id: 10, name: '休闲' }, { id: 11, name: '策略' }, { id: 12, name: '棋牌' }, { id: 13, name: '音乐' }, { id: 14, name: '益智' }, { id: 15, name: '体育' }, { id: 16, name: 'AVG' }];
      return list.some(function (item) {
        return row.app_custom_cids.indexOf(item.id) !== -1;
      });
    },
    isMP4: function isMP4(row) {
      return row.attachment_url.toLowerCase().indexOf('.mp4') !== -1;
    },
    submitDialog: function submitDialog() {
      var _this2 = this;

      this.$refs['featureTagForm'].validate().then(function (res) {
        _this2.dialogConfig.loading = true;
        updateMaterialTag(_.cloneDeep(_this2.dialogValue)).then(function (e) {
          _this2.dialogConfig.visible = false;
          _this2.dialogConfig.loading = false;
          _this2.getDemandList();
          _this2.$message({
            message: '更新成功',
            type: 'success'
          });
        });
      });
    },
    editMaterialTag: function editMaterialTag(row) {
      this.dialogConfig.visible = true;
      this.autoCompleteTag = row.material_tag_ids;
      this.dialogValue.id = row.id;
    },
    getFeatureTagData: function getFeatureTagData() {
      var _this3 = this;

      if (this.schemeValue.featureTagData.length) return;
      getAppTagList({
        type: 1
      }).then(function (res) {
        var list = _.get(res, 'data.data.tag.sub_tags', []);
        _this3.schemeValue.featureTagData = list;
      }).catch(function () {});
    },
    autoPickTagById: function autoPickTagById(ids, tagTree) {
      var targetValue = {};
      var _ids = ids.split(',');
      var pickId = function pickId(targetId, obj) {
        obj.map(function (item) {
          if (Number(item.id) === Number(targetId) && targetValue[item.pid]) {
            targetValue[item.pid].push([item.id]);
          } else if (Number(item.id) === Number(targetId)) {
            targetValue[item.pid] = [[item.id]];
          }
          if (item.sub_tags) {
            pickId(targetId, item.sub_tags);
          }
        });
      };
      _ids.map(function (id) {
        pickId(id, tagTree);
      });

      return targetValue;
    },
    updateFeatureTag: function updateFeatureTag(tag) {
      this.dialogValue.tag_ids = tag;
    }
  },
  mounted: function mounted() {
    this.getDemandList();
    this.getFeatureTagData();
  }
};